import React, { useState } from 'react';
import { Skeleton, Box } from '@mui/material';

export default function ImageSkeleton({
  src,
  alt,
  width = '100%',
  height = 300,
  borderRadius = 0,
  ...rest
}) {
  const [loaded, setLoaded] = useState(false);

  return (
    <Box
      sx={{
        position: 'relative',
        width,
        height,
        borderRadius,
        overflow: 'hidden',
      }}
    >
      {/* Skeleton shown while loading */}
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          borderRadius,
          opacity: loaded ? 0 : 1,
          transition: 'opacity 0.4s ease-in-out',
        }}
      />

      {/* Actual image */}
      <Box
        component="img"
        src={src}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius,
          opacity: loaded ? 1 : 0,
          transition: 'opacity 0.4s ease-in-out',
        }}
        {...rest}
      />
    </Box>
  );
}
